import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import type { RenderFilter } from "./types";

export const useShouldShowAvatarSetFilter = (
  filters: RenderFilter[],
): RenderFilter[] => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  if (isAdmin) {
    return filters;
  }

  return filters.filter(filter => filter.name !== "is_avatar_set");
};
